/**
 * Register the service worker and subscribe the user to Web Push using the
 * server's VAPID public key. Silent no-op if unsupported or permission denied.
 */
import api from "@/api/client";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registerPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  if (Notification.permission !== "granted") return false;
  try {
    const reg = await navigator.serviceWorker.register("/service-worker.js");
    // Wait for it to be ready
    await navigator.serviceWorker.ready;

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      const { data } = await api.get("/push/public-key");
      const pub = data.public_key;
      if (!pub) return false;
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(pub),
      });
    }
    const raw = sub.toJSON();
    await api.post("/push/subscribe", {
      endpoint: raw.endpoint,
      keys: raw.keys,
    });
    return true;
  } catch (e) {
    return false;
  }
}
